import React from "react";
import { getMatchSource, MatchSource } from "helpers/codeMatching";

import { getSelectedGroups } from "modules/MatchingModule/helpers/getSelectedGroups";
import { useMatchingContext } from "modules/MatchingModule/MatchingModule.context";

// Source codes and description text of the rows selected in the table, for highlighting matching item codes
export const useSelectedGroupsMatchSource = (): MatchSource => {
  const { matchGroupsList, selectedGroupIds } = useMatchingContext();

  return React.useMemo(
    () => getMatchSource(getSelectedGroups(matchGroupsList, selectedGroupIds)),
    [matchGroupsList, selectedGroupIds]
  );
};
